import axios from "axios";
import "babel-polyfill";
import Vue from "vue";
import StringHelper from "../Commons/StringHelper";

declare let window: {
  inscriptionFlowSettings: any;
};

// class-component-hooks.js
import { Component } from "vue-property-decorator";
// Register the router hooks with their names
Component.registerHooks([
  "beforeRouteEnter",
  "beforeRouteLeave",
  "beforeRouteUpdate",
]);

import InscriptionFlow from "./InscriptionFlow.vue";

// Définition de propriétés globales pour toutes les vues :
Vue.prototype.$http = axios;
// Vue.prototype.$eventBus = EventBus;
Vue.prototype.$appSettings = window["inscriptionFlowSettings"] as any;
Vue.prototype.$texts = window["inscriptionFlowSettings"].Texts;
Vue.prototype.$stringHelper = StringHelper;
Vue.config.productionTip = false;

import VeeValidate, { Validator } from "vee-validate";
import fr from "vee-validate/dist/locale/fr";

Vue.use(VeeValidate, { errorBagName: "formErrors" });

import VueRouter from "vue-router";
import { routes } from "./routes/Routes";

Vue.use(VueRouter);
const router = new VueRouter({ routes });

// Install and Activate the fr locale.
Validator.localize("fr", fr);
// Vue.prototype.$eventBus = EventBus;

new Vue({
  el: "#app",

  components: {
    InscriptionFlow,
  },

  router,

  template: "<inscription-flow></inscription-flow>",
});
